/**
 * A springy ease that slightly overshoots, for small playful lifts like an
 * avatar hopping on hover.
 */
export const SPRING_EASE_CLASS = 'ease-[cubic-bezier(.34,1.56,.64,1)]';
